import { ActionBannerWithButton } from "@mallardbay/lib-react-components"
import React from "react"

import RequestQuoteModal from "~components/shared/request-quote-modal/request-quote-modal"
import useDisclosure from "~components/shared/todo-lib-react-components/use-disclosure"
import COPY from "~config/copy-constants"
import { useUser } from "~config/user-provider"
import type {
    ListingFieldsFragment,
    PublicListingFieldsFragment,
} from "~graphql/generated/graphql"

interface Props {
    readonly listing: PublicListingFieldsFragment | ListingFieldsFragment
    readonly trackingSource: string
    readonly trackingSourceUrl?: string
}

export default function RequestQuoteBanner({
    listing,
    trackingSource,
    trackingSourceUrl,
}: Props) {
    const { user } = useUser()
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <ActionBannerWithButton
                title={COPY.REQUEST_A_QUOTE}
                description={COPY.REQUEST_QUOTE_DESCRIPTION}
                buttonLabel={COPY.REQUEST_A_QUOTE}
                buttonOnClick={onOpen}
            />
            <RequestQuoteModal
                isOpen={isOpen}
                onClose={onClose}
                listing={listing}
                user={user}
                // force a re-render when the user changes
                key={user?.id}
                trackingSource={trackingSource}
                trackingSourceUrl={trackingSourceUrl}
            />
        </>
    )
}
